import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { v4 as uuid } from 'uuid';
import { User } from '../model/user';
import { CommonService } from 'src/app/services/common.service';
import { ErrorTraceService } from 'src/app/shared/services/error-trace.service';

@Injectable()
export class HttptokeninterceptorInterceptor implements HttpInterceptor {
  machineId = 'Portal';
  constructor(
    private commonService: CommonService,
    private datePipe: DatePipe,
    private errorTraceService: ErrorTraceService
    ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lang = localStorage.getItem('userTempLang') ? localStorage.getItem('userTempLang') : 'en';
    const token = localStorage.getItem('gateway-access-token') || '';
    const userType = localStorage.getItem('userType') || '';
    const currentDate = new Date();
    
    const userDetails = localStorage.getItem('USER');
    const user: User = userDetails ? JSON.parse(userDetails) : null;

    const getCustomer = localStorage.getItem('selectedCustomer');
    const selectedCustomer = getCustomer ? JSON.parse(getCustomer) : null;
    const getFacility = localStorage.getItem('selectedFacility');
    const selectedFacility = getFacility ? JSON.parse(getFacility) : null;
    const getBusinessUnit = localStorage.getItem('selectedBusinessUnit');
    const selectedBusinessUnit = getBusinessUnit ? JSON.parse(getBusinessUnit) : null;

    const machineName = navigator.platform;
    const isLocalEnv = environment.localEnviornment === 'true';
    
    const commonHeaders = {
      'Accept-Language': lang,
      'APPID': environment.apiRlogBussServAPPID,
      'appName': 'FLARE',
      'fcyId': request.headers.has('fcyId')
        ? request.headers.get('fcyId') // Use the explicitly set value
        : selectedFacility?.facilityID?.toString() || '',
      'facId': request.headers.has('facId')
        ? request.headers.get('facId') // Use the explicitly set value
        : selectedFacility?.facilityID?.toString() || '',
      'buId': request.headers.has('buId')
        ? request.headers.get('buId') // Use the explicitly set value
        : selectedBusinessUnit?.buId?.toString() || '',
      'custId': request.headers.has('custId')
        ? request.headers.get('custId') // Use the explicitly set value
        : selectedCustomer?.customerId?.toString() || '',
      'custName': selectedCustomer?.customerName?.toString() || '',
      'FCY_TIMEZONE': selectedFacility?.timeZone || '',
      'FCY_TZ_GMT_OFFSET': selectedFacility?.gmtOffsetHours?.toString() || '',
      'FSC_LOGGED_IN_USER': localStorage.getItem('USERID') || '',
      'FSC_USER_ID': localStorage.getItem('USER-ID') || '',
      'FSC_USER': localStorage.getItem('USERID') || '',
      'Module': 'PORTAL',
      'UUID': uuid(),
      'tracePath': 'Portal',
      'machineId': this.machineId || '',
      'machineName': machineName || '',
      'enrollmentType': selectedCustomer?.enrollmentType?.toString() || 'FL',
      'timeStamp': this.datePipe.transform(currentDate, 'yyyy MMM dd HH:mm:ss.SSS zzzz'),
      'currentMenu': localStorage?.getItem('selected_menu') || '',
      'menuName': sessionStorage?.getItem('selected_menu_name') || '',
    };

    const authHeaders = {
      FCLCookie: user?.fdxLogin ? `fdx_login=${user.fdxLogin}` : '',
      FCLAuthToken: user?.fclAuthToken ? `Bearer ${user.fclAuthToken}` : '',
      OktaJWTToken: user?.jwtToken && userType === 'I' ? user.jwtToken : '',
      OktaTempJWTToken: user?.jwtToken && userType === 'T' ? user.jwtToken : ''
    };

    // this.getIPAddress();

    if (isLocalEnv && 
      !request.url.includes('.services.logistics.fedex.com') && 
      !request.url.includes('login') && 
      !request.url.includes('accounts') &&
      !request.url.includes('apidrt.idev.fedex.com')
      ) {
      if (request.url.includes('rlog')) {
        console.log('request url 1', {
          ...commonHeaders,
          Authorization: 'Basic ' + btoa('PPPPortal:Fedex@123'),
          ...authHeaders,
          localEnv: 'true'
        });
        request = this.cloneRequestWithHeaders(request, {
          ...commonHeaders,
          Authorization: 'Basic ' + btoa('PPPPortal:Fedex@123'),
          ...authHeaders,
          localEnv: 'true'
        });
      } else {
        const authToken = request.url.includes('microsoftOauth') || request.url.includes('microsoftPowerBI') 
          ? 'Basic UFBQUG9ydGFsOkZlZGV4QDEyMw==' 
          : '';

        console.log('request url 2', {
          ...commonHeaders,
          Authorization: authToken,
          ...authHeaders
        });
        request = this.cloneRequestWithHeaders(request, {
          ...commonHeaders,
          Authorization: authToken,
          ...authHeaders
        });
      }
    } else if (
      !request.url.includes('login') && 
      !request.url.includes('token') && 
      !request.url.includes('accounts')
      ) {
        if (request.url.includes('rlog')) {
          const authType = 'Bearer ' + token;
          
          console.log('request url 3', {
            ...commonHeaders,
            Authorization: authType,
            ...authHeaders,
            localEnv: 'false'
          });
          request = this.cloneRequestWithHeaders(request, {
            ...commonHeaders,
            Authorization: authType,
            ...authHeaders,
            localEnv: 'false'
          });
        } else if (request.url.includes('v2/users/userinfo')) {
          const authType = 'Bearer ' + user?.fclAuthToken;
          request = this.cloneRequestWithHeaders(request, {
            Authorization: authType
          });
        } else{
          const authType = 'Bearer ' + token;
          console.log('request url 4', {
            ...commonHeaders,
            Authorization: authType,
            ...authHeaders
          });
          request = this.cloneRequestWithHeaders(request, {
            ...commonHeaders,
            Authorization: authType,
            ...authHeaders
          });
        }
    }

    const requestTraceSeed = {
      uuid: request.headers.get('UUID') || '',
      url: request.url,
      method: request.method,
      requestPayload: request.body
    };

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const trace = {
          ...requestTraceSeed,
          response: error?.error ?? error,
          timestamp: new Date().toISOString()
        };

        this.errorTraceService.setLastErrorTrace(trace);
        return throwError(error);
      })
    );
  }

  private cloneRequestWithHeaders(request: HttpRequest<any>, headers: { [key: string]: string }) {
    return request.clone({ setHeaders: headers, withCredentials: true });
  }
}
